import JSZip from 'jszip'

/**
 * Multi-file ZIP bundling (`export-validation` spec: "Split into three
 * segments offers a complete ZIP"). Used for batch/split results where
 * the caller wants one download instead of N — never used as a
 * replacement for individual downloads, per the master spec's "in
 * addition to individual downloads" requirement (that choice lives in
 * the UI layer).
 */

export interface ZipFileEntry {
  name: string
  data: Uint8Array | string
}

export async function bundleFilesToZip(files: ZipFileEntry[]): Promise<Uint8Array> {
  const zip = new JSZip()
  for (const file of files) {
    zip.file(file.name, file.data)
  }
  return zip.generateAsync({ type: 'uint8array' })
}
